import React from 'react';
import { hashHistory } from 'react-router';
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import ButtonInc from '../../../../../shared-ui/ButtonInc';
import { formatDateLocale } from '../../../../../lib/utils.es6';

export function DisplayClaims(currencyCode, classes, claims, type, toggleAssignLawyerDialog, showAssignLawyer, tabIndex) {
  console.log("claims", claims, "type", type)

  const claimsFormatted = claims.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map(claim => {
    return {
      ...claim,
      grower_number: claim.claim_details.policy_number
    }
  })

  // Check if any claim has Legal Cover benefit type
  const hasLegalCover = claims.some(claim => 
    claim.benefits && claim.benefits.some(benefit => benefit.type === "Legal Cover")
  );

  // Base columns that are always shown
  const baseColumns = [
    {
      title: 'Claim number', field: 'claim_number', render: rowData => <>
        {rowData.claim_number || "N/A"}
      </>
    },
    {
      title: 'Policy  Number', field: 'grower_number'
    },
    // {
    //   title: 'Payable Amount', field: 'benefit_usages', render: rowData => <>
    //     {`${currencyCode} ${(rowData.benefit_usages.reduce((psum, benefit) => psum + benefit.benefit_amount_in_cents, 0) / 100).toLocaleString()}` || "N/A"}
    //   </>
    // },
    {
      title: 'Created At', field: 'created_at', render: rowData => <>
        {formatDateLocale(rowData.created_at) || "N/A"}
      </>
    },
    { title: 'Created By', field: 'web_agent_name' },
    {
      title: 'Invoice Status', field: 'benefit_usages', render: rowData => {
        if (!rowData.benefit_usages || rowData.benefit_usages.length === 0) {
          return <>No Invoices</>;
        }

        const paidInvoices = rowData.benefit_usages.filter(benefit => benefit.marked_as_paid_date !== null).length;
        const totalInvoices = rowData.benefit_usages.length;
        const pendingInvoices = totalInvoices - paidInvoices;

        return (
          <>
            Paid: {paidInvoices} | Pending: {pendingInvoices}
          </>
        );
      }
    }
  ];

  // Lawyer assignment column for Legal Cover claims
  const lawyerColumn = {
    title: 'Lawyer Assigned', field: 'lawyer_assigned', render: rowData => {
      const lawyerName = rowData.claim_details && rowData.claim_details.additional_details && rowData.claim_details.additional_details.lawyer_name;
      return <>{lawyerName || "Not Assigned"}</>;
    }
  };

  // Action column
  const actionColumn = { 
    title: 'action', field: 'claimaction', render: rowData => {
      const isLegalClaim = rowData.benefits && rowData.benefits.some(benefit => benefit.type === "Legal Cover");
      
      // Show assign lawyer button for Legal Cover claims in Docs Pending (0) and Verification (1) tabs
      const showAssignButton = showAssignLawyer && isLegalClaim;
      
      return <div className={classes.claimactionbt}>
        <ButtonInc
          onClick={() => hashHistory.push(`admin/claim-processing-v2/${rowData.guid}`)}
          variant="contained">View Claim</ButtonInc>
        
        {showAssignButton && (
          <ButtonInc
            onClick={() => toggleAssignLawyerDialog(rowData.guid)}
            variant="contained" >
            Assign Lawyer
          </ButtonInc>
        )}
      </div>;
    }
  };

  // Conditionally add lawyer column if Legal Cover claims exist
  const columns = hasLegalCover 
    ? [...baseColumns, lawyerColumn, actionColumn]
    : [...baseColumns, actionColumn];

  return (
  <Grid container spacing={2}>
    <Grid item xs={12} md={12} sm={12}>
      <TableInc
        columns={columns}
        data={claimsFormatted}
        options={{
          pageSize: 5,
          showTitle: false,
        }} />

    </Grid>
  </Grid>
  )

}
